import * as React from 'react';
import { SVGProps } from 'react';

const SvgHoleDiameter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M31.733 13.073 19.7 6.13 7.813 13.04l-.045 14.034 12 6.931 12-6.932-.035-14Zm-1.125.648v.114l-.102-.17.102.056ZM19.712 7.437l10.34 5.966-10.26 6L9.517 13.37 19.71 7.437Zm-10.762 6.92 10.262 6.035v11.966L8.915 26.415l.034-12.057Zm11.398 18V20.38l10.261-6 .035 12.023-10.296 5.955Z'
      fill='#000'
    />
    <ellipse
      cx={19.768}
      cy={13.268}
      rx={4.61}
      ry={2.634}
      fill='#FFEFE6'
      stroke='#FF4D00'
    />
  </svg>
);

export default SvgHoleDiameter;
